import { GET_YOUTUBE_VIDEOS_WITH_STATS_SUCCESS, YOUTUBE_OVERVIEW_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { data: null, errors: null };

export default function ytOverview(state = INITIAL_STATE, action) {

  switch (action.type) {
    case YOUTUBE_OVERVIEW_SUCCESS:
      return { ...state, data: action.payload.data, errors: null };
    case GET_YOUTUBE_VIDEOS_WITH_STATS_SUCCESS:
      return { ...state, videosWithStats: action.payload.data, errors: null }
    default:
      return state;
  }
}